var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 11.8C10.5405 11.8 12.6 9.74051 12.6 7.2C12.6 4.65949 10.5405 2.6 7.99999 2.6C5.45948 2.6 3.39999 4.65949 3.39999 7.2C3.39999 9.74051 5.45948 11.8 7.99999 11.8ZM8.59999 12.7682C11.4107 12.4689 13.6 10.0901 13.6 7.2C13.6 4.10721 11.0928 1.6 7.99999 1.6C4.9072 1.6 2.39999 4.10721 2.39999 7.2C2.39999 10.1583 4.69388 12.5808 7.59999 12.7859V14.4H8.59999V12.7682ZM7.99999 8.6C8.77319 8.6 9.39999 7.9732 9.39999 7.2C9.39999 6.4268 8.77319 5.8 7.99999 5.8C7.2268 5.8 6.59999 6.4268 6.59999 7.2C6.59999 7.9732 7.2268 8.6 7.99999 8.6ZM7.99999 9.6C9.32548 9.6 10.4 8.52548 10.4 7.2C10.4 5.87452 9.32548 4.8 7.99999 4.8C6.67451 4.8 5.59999 5.87452 5.59999 7.2C5.59999 8.52548 6.67451 9.6 7.99999 9.6Z",
    fill: "#6E7882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStops);
export default __webpack_public_path__ + "static/media/icon-stops.682287212d1eeefc2b14771b2226cae4.svg";
export { ForwardRef as ReactComponent };